import React from 'react'
import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'

export const HznSourcingGroupsMultiEdit = () => {
  return (
    <MicroFrontEnd
      name="HznSourcingGroupsMultiEdit"
      src={apiConfig.microFrontEnds.HznSourcingGroupsMultiEdit}
    />
  )
}

export default HznSourcingGroupsMultiEdit
